import ErrorMessage from '@shared/components/ErrorMessage/ErrorMessage';

import { ReactComponent as Clock } from 'assets/icons/Clock.svg';

import { formatDateRange } from './utils';
import useCreateNewRoomDataContext from '../../CreateNewRoomDataProvider/useCreateNewRoomDataContext';
import { CreateNewRoomStepsEnum } from '../../utils';
import EditButton from '../EditButton';

const ScheduleReview = () => {
  const {
    roomForm: {
      getValues,
      formState: { errors },
    },
  } = useCreateNewRoomDataContext();

  const [startDate, startTime, endDate, endTime, timeZone] = getValues([
    'startDate',
    'startTime',
    'endDate',
    'endTime',
    'timeZone',
  ]);

  const dateErrors = errors.startDate || errors.startTime || errors.endDate || errors.endTime;
  const nonZeroSign = timeZone > 0 ? '+' : '';
  const sign = timeZone ? nonZeroSign : '±';
  const timeZoneDisplay = `(GMT ${sign}${timeZone})`;
  const dateDisplay = formatDateRange({
    start: { date: startDate, time: startTime },
    end: { date: endDate, time: endTime },
  });

  return (
    <div className="flex gap-5">
      <Clock className="stroke-gray-60 h-6 w-6 shrink-0 stroke-1.5 mt-1" />{' '}
      <div className="flex flex-col w-full">
        <div className="w-full flex justify-between items-center gap-1">
          <span className="text-black text-size-sm">{`${dateDisplay} ${timeZoneDisplay} `}</span>
          <EditButton step={CreateNewRoomStepsEnum.CREATE_ROOM} />
        </div>
        <ErrorMessage message={dateErrors?.message} className="mt-2" />
      </div>
    </div>
  );
};

export default ScheduleReview;
